import React from 'react';
import RadioButton from '../RadioButton';

/**
 * RadioButton/Medium — Figma 4033:280
 * 24px selector · title `typo-body` · description `typo-body-sm` · gray-10 fill.
 */
const RadioButtonMedium = (props) => <RadioButton {...props} size="medium" />;

export default RadioButtonMedium;
